module.exports = __webpack_public_path__ + "advanced.png?a85bd1bd3cd6c4f9c40687010592f5a7";